import { useState } from 'react';

export default function Tooltip({ text, children }: any) {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const handleMouseEnter = (e: any) => {
    const rect = e.target.getBoundingClientRect();
    setPosition({ top: rect.top - 10, left: rect.left + rect.width / 2 });
    setVisible(true);
  };

  const handleMouseLeave = () => {
    setVisible(false);
  };

  return (
    <>
      <span
        className="tooltip-trigger"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </span>
      {visible && (
        <div
          className="tooltip-text"
          style={{
            position: "fixed",
            top: position.top,
            left: position.left,
            transform: "translate(-50%, -100%)",
            zIndex: 1000,
            backgroundColor: "black",
            color: "white",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          {Array.isArray(text) ? text.map((line, index) => <div key={index}>{line}</div>) : text}
        </div>
      )}
    </>
  );
}
